import FetchHelpers from 'utils/FetchHelpers';
import { apiRoutes } from 'routes';

export default {
  index(params) {
    const url = apiRoutes.apiV1LoanOfficerRealEstateAgentsPath();

    return FetchHelpers.get(url, params);
  },
};



// WEBPACK FOOTER //
// ./src/repositories/loanOfficer/RealEstateAgentsRepository.js